import { useEffect } from "react";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { getNewsPost, selectNewsPost, selectLoading, resetState } from "./DevelopmentNewsPostSlice";
import { useDispatch, useSelector } from "react-redux";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { sanitizeHtml } from "cpl-react-common/Helpers/HtmlSanitizerHelpers";
import "./DevelopmentNewsPost.scss";

type DevelopmentNewsPostProps = {
  developmentNewsID: string;
};

const DevelopmentNewsPost = ({ developmentNewsID }: DevelopmentNewsPostProps) => {
  const thunkDispatch = useThunkDispatch();
  const dispatch = useDispatch();
  const newsPost = useSelector(selectNewsPost);
  const loading = useSelector(selectLoading);

  useEffect(() => {
    if (developmentNewsID != null) {
      thunkDispatch(getNewsPost(developmentNewsID));
    }

    return function () {
      dispatch(resetState());
    };
  }, [dispatch, thunkDispatch, developmentNewsID]);

  return (
    <ActivityIndicator isBusy={loading}>
      <div className="card cpl-card news-post-card">
        {newsPost != null && (
          <div className="card-body h-100">
            <div className="news-post-text-header">
              <h3 className="news-post-title">{`${newsPost.title}`}</h3>
              <h5>Date: {newsPost.postedOn?.toCPLCommentDateTimeString()}</h5>
            </div>
            <div className="news-post-text-body">
              <img
                alt="news post"
                className="d-block w-100 mw-350px w-md-350px h-250px object-fit-contain float-none float-md-end mx-auto mx-md-0"
                src={newsPost.imagePath != undefined ? newsPost.imagePath : "/media/property-placeholder.jpg"}
              ></img>
              <div
                className="news-post-content"
                dangerouslySetInnerHTML={{ __html: sanitizeHtml(newsPost.body) }}
              ></div>
            </div>
          </div>
        )}
      </div>
    </ActivityIndicator>
  );
};

export default DevelopmentNewsPost;
